export const getSetting = (settings: any[], settingName: string) => {
  return settings?.find((setting) => setting.setting === settingName);
};
